import React from 'react';
import CheckmarkIcon from '../icons/checkmark/CheckmarkIcon';
import './UspItem.scss';

const UspItem = ({ title }) => {
	return (
		<div className="usp-container">
			<CheckmarkIcon modifierClass="complete-icon" />
			{title}
		</div>
	);
};

export default UspItem;
